module.exports = __webpack_public_path__ + "media/images/buddy_blank-398827d3afb3bc0384b45633cf9258e1.png";